const isClient = typeof window !== 'undefined';
export const getUserSettings = () => {
    var _a;
    try {
        return (isClient &&
            (JSON === null || JSON === void 0 ? void 0 : JSON.parse(((_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem('userSettings')) || '""')));
    }
    catch (e) {
        return JSON === null || JSON === void 0 ? void 0 : JSON.parse('""');
    }
};
export const setUserSetting = (type, value) => {
    var _a;
    if (isClient && (window === null || window === void 0 ? void 0 : window.localStorage)) {
        const userSettings = getUserSettings();
        let newUserSettings;
        switch (type) {
            case 'spaceCollection':
                newUserSettings = {
                    ...userSettings,
                    spaceCollections: {
                        ...userSettings === null || userSettings === void 0 ? void 0 : userSettings.spaceCollections,
                        [value === null || value === void 0 ? void 0 : value.id]: {
                            isExpanded: value === null || value === void 0 ? void 0 : value.isExpanded,
                            name: value === null || value === void 0 ? void 0 : value.name,
                        },
                    },
                };
                break;
            case 'appearance':
                newUserSettings = {
                    ...userSettings,
                    appearance: {
                        ...userSettings === null || userSettings === void 0 ? void 0 : userSettings.appearance,
                        ...value,
                    },
                };
                break;
            case 'tableSelectedFields':
                newUserSettings = {
                    ...userSettings,
                    tableSelectedFields: {
                        ...userSettings === null || userSettings === void 0 ? void 0 : userSettings.tableSelectedFields,
                        ...value,
                    },
                };
                break;
            case 'timeFrames':
                newUserSettings = {
                    ...userSettings,
                    timeFrames: {
                        ...userSettings === null || userSettings === void 0 ? void 0 : userSettings.timeFrames,
                        ...value,
                    },
                };
                break;
            case 'postListOrderBy':
                newUserSettings = {
                    ...userSettings,
                    postListOrderBy: {
                        ...userSettings === null || userSettings === void 0 ? void 0 : userSettings.postListOrderBy,
                        ...value,
                    },
                };
                break;
            default:
                // Code should never reach the default case
                // eslint-disable-next-line no-case-declarations
                const exhaustiveCheck = type;
                return exhaustiveCheck;
        }
        (_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.setItem('userSettings', JSON === null || JSON === void 0 ? void 0 : JSON.stringify(newUserSettings));
        return newUserSettings;
    }
};
//# sourceMappingURL=index.js.map